import axios from 'axios';
import { EventType } from '@/shared/enums';
import { Deferred } from '@/shared/libs';
import OneTrust from './onetrust';

export default async ({ $deferredLoader, $EventBus, $services }, inject) => {
  const info = $services.resolve('info');

  await info.fetch();
  const oneTrustUrl = info.oneTrustUrl;
  $deferredLoader.oneTrust = new Deferred();

  const oneTrust = new OneTrust();
  inject('oneTrust', oneTrust);

  function loadOneTrust() {
    if (!oneTrustUrl) {
      return Promise.reject();
    }

    return axios.get(oneTrustUrl, { responseType: 'document' }).then((response) => {
      const scripts = Array.from(response.data.querySelectorAll('script'));

      scripts.forEach((script) => {
        const scriptElement = document.createElement('script');
        const attributes = Array.from(script.attributes);

        attributes.forEach(({ name, value }) => {
          scriptElement.setAttribute(name, value);
        });

        scriptElement.innerHTML = script.innerHTML;
        document.head.appendChild(scriptElement);
      });
    });
  }

  function waitForOneTrust() {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(), 10000);
      window.OptanonWrapper = () => {
        clearTimeout(timeout);
        resolve();
      };
    });
  }

  $deferredLoader.appReady.promise
    .then(() => {
      if (window.OneTrust) {
        return;
      }

      const isGtmLoaded = window.dataLayer.find(({ event }) => event === 'gtm.load');

      // if gtm is loaded, then oneTrust will be loaded through gtm
      if (isGtmLoaded) {
        return waitForOneTrust();
      }

      // if gtm has been blocked we must load oneTrust manually
      return loadOneTrust()
        .then(() => waitForOneTrust());
    })
    .then(() => {
      $EventBus.on(EventType.OPEN_PREFERENCE_CENTER, () => oneTrust.open());

      return oneTrust.init();
    })
    .catch(() => {})
    .then(() => {
      $deferredLoader.oneTrust.resolve();
    });
};
